import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=03e5c8aa&scoped=true"
import script from "./FontSelector.vue?vue&type=script&lang=js"
export * from "./FontSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5c8aa",
  null
  
)

export default component.exports